import { format, parse } from 'date-fns';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
export const MAT_DATE_FNS_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/dd/yyyy',
  },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMM yy',
    dateA11yLabel: 'MMMM d, yy',
    monthYearA11yLabel: 'MMMM yy',
  },
};
@Injectable({
  providedIn: 'root',
})
export class MgoDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: any): string {
    return format(date, displayFormat);
  }

  parse(value: string, parseFormat?: any) {
    const parsedDate = parse(value, parseFormat, new Date());
    const parsedYear = parsedDate.getFullYear();
    if (parsedYear < 100) {
      return new Date(
        parsedYear + 1900,
        parsedDate.getMonth(),
        parsedDate.getDate()
      );
    } else {
      return parsedDate;
    }
  }

  /* take time like HH:MM AM/PM and convert to Native Date Object format */
  convertHour(hour: string, date: Date = new Date()) {
    const currentDate = format(date, 'yyyy/MM/dd');
    return new Date(currentDate + ' ' + hour);
  }
}
